import React, { useRef, useEffect } from "react";
import Slider from "react-slick";

import {
  Root,
  Container,
  Subtitle,
  Title,
  CardsWrapper,
  GrandSlider,
  GrandTextContainer,
  GrandText,
  Badge,
  CardTitle,
  List,
  ListItem,
} from "./Sweepstakes.style";

import grandPrizeSrc from "../../images/grand-prize.svg";
import firstPrizeSrc from "../../images/first-prize.svg";

import useIntersection from "../../hooks/useIntersection";
import { grandPrize, firstPrize, sliderSettings } from "./config";
import SliderStyled from "../SliderStyled/SliderStyled";

const Sweepstakes = ({ id, onIntersected }) => {
  const ref = useRef(null);
  const isIntersected = useIntersection(ref);

  useEffect(() => {
    if (isIntersected) {
      onIntersected();
    }
  }, [isIntersected, onIntersected]);

  return (
    <Root ref={ref} id={id}>
      <Container>
        <Subtitle>win your prize</Subtitle>
        <Title>Sweepstakes</Title>

        <CardsWrapper>
          <GrandSlider>
            <SliderStyled>
              <Slider {...sliderSettings}>
                {grandPrize.map((slide, idx) =>
                  slide.href == null ? (
                    <img key={idx} src={slide.image} alt="" />
                  ) : (
                    <a
                      key={idx}
                      href={slide.href}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={slide.image} alt="" />
                    </a>
                  ),
                )}
              </Slider>
            </SliderStyled>
          </GrandSlider>

          <GrandTextContainer>
            <GrandText>
              <Badge src={grandPrizeSrc} alt="Grand Prize" $isGrand />
              <CardTitle>
                Ole Smoky & Big Green Egg<sup>®</sup>
                <br />
                Ultimate BBQ Package (QTY&nbsp;1)
              </CardTitle>

              <List>
                <ListItem>
                  Large Big Green Egg<span>®</span> in an intEGGrated
                  Nest+Handler with Mates
                </ListItem>
                <ListItem>Ole Smoky BBQ Tool Set</ListItem>
                <ListItem>Ole Smoky Apron</ListItem>
                <ListItem>Ole Smoky Retro Webbed Chair</ListItem>
                <ListItem>
                  Big Green Egg<span>®</span> Cookbook
                </ListItem>
              </List>
            </GrandText>
          </GrandTextContainer>
        </CardsWrapper>

        <CardsWrapper>
          <GrandSlider>
            <SliderStyled>
              <Slider {...sliderSettings}>
                {firstPrize.map((slide, idx) =>
                  slide.href == null ? (
                    <img key={idx} src={slide.image} alt="" />
                  ) : (
                    <a
                      key={idx}
                      href={slide.href}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={slide.image} alt="" />
                    </a>
                  ),
                )}
              </Slider>
            </SliderStyled>
          </GrandSlider>

          <GrandTextContainer>
            <GrandText>
              <Badge src={firstPrizeSrc} alt="Grand Prize" />
              <CardTitle>
                Ole Smoky & Big Green Egg<sup>®</sup>
                <br />
                Ultimate Grill Kit (QTY&nbsp;3)
              </CardTitle>

              <List>
                <ListItem>Ole Smoky BBQ Tool Set</ListItem>
                <ListItem>Ole Smoky Apron</ListItem>
                <ListItem>Ole Smoky Retro Webbed Chair</ListItem>
                <ListItem>
                  Big Green Egg<span>®</span> Cookbook
                </ListItem>
              </List>
            </GrandText>
          </GrandTextContainer>
        </CardsWrapper>
      </Container>
    </Root>
  );
};

export default Sweepstakes;
